


















































































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import { Item } from '@/api/paypal';
import { Action } from 'vuex-class';
import { Redemption } from '@/api/stripe';

@Component({
  filters: {
    money: (value: string | number) => {
      const val = Number(value);
      return '$' + val.toFixed(2);
    },
  },
})
export default class StripeConfirmNoPay extends Vue {
  @PropSync('show', { type: Boolean }) public visible!: boolean;
  @Prop({type: Array, required: true}) public readonly items!: Item[];
  @Prop({type: String, required: true}) public readonly name!: string;
  @Prop({type: String, required: true}) public readonly email!: string;
  @Prop({type: String, default: ''}) public readonly phone!: string;
  @Prop({type: String, required: true}) public readonly giftcard!: string;
  @Action('tickets/redeemGiftCard') public readonly redeem!: (req: Redemption) => Promise<Response>;

  public get total(): number {
    return this.items.reduce((acc, cv) => acc + (Number(cv.quantity) * Number(cv.unit_amount.value)), 0);
  }

  public async redeemGifts() {
    const resp = await this.redeem({
      name: this.name,
      email: this.email,
      phone: this.phone,
      items: this.items,
      giftcard: this.giftcard});

    if (resp.ok) {
      this.visible = false;
      this.$emit('redeem:success');
    }
  }
}
